module.exports = __webpack_public_path__ + "static/media/magic-wand.227ce27d.webp";